import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom validator for key fields.
 * Ensures the value is all lowercase, has no whitespace, no special characters, and is unique.
 * @param existingKeys Array of existing keys to ensure uniqueness.
 * @param oldKey key sets before is still allowed.
 * @returns Validator function that checks the control value.
 */
export function keyValidator(
  existingKeys: string[],
  oldKey?: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    return validateIndicatorKeyValue(value, existingKeys, oldKey);
  };
}
export function validateIndicatorKeyValue(
  value: string,
  existingKeys: string[],
  oldKey?: string
) {
  let errors: ValidationErrors = {};

  if (!value) {
    errors = { ...errors, ...{ required: true } };
  }

  // Check for lowercase letters only
  if (value !== value.toLowerCase()) {
    errors = { ...errors, ...{ lowercaseRequired: true } };
  }

  // Check for no whitespaces
  if (/\s/.test(value)) {
    errors = { ...errors, ...{ whitespaceNotAllowed: true } };
  }

  // Check for no special characters (only allow alphanumeric)
  if (/[^a-z0-9_]/.test(value)) {
    errors = { ...errors, ...{ noSpecialCharsAllowed: true } };
  }

  if (value !== oldKey && existingKeys.includes(value)) {
    errors = { ...errors, ...{ notUnique: true } };
  }
  return Object.keys(errors).length ? errors : null;
}
